import { forwardRef } from 'react';
import { jsxs, jsx } from 'react/jsx-runtime';

const SvgEye1 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/jsxs("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 60 60",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId,
    ...props,
    children: [title ? /*#__PURE__*/jsx("title", {
      id: titleId,
      children: title
    }) : null, /*#__PURE__*/jsx("path", {
      d: "M30 33.608a4.016 4.016 0 1 1 4.016-4.017A4.02 4.02 0 0 1 30 33.608m0-13.025a9.009 9.009 0 1 0 9.009 9.008A9.02 9.02 0 0 0 30 20.583",
      fill: "currentColor"
    }), /*#__PURE__*/jsx("path", {
      d: "M51.318 30.3a23.65 23.65 0 0 1-21.172 13.181h-.1A23.95 23.95 0 0 1 8.678 30.159l-.11-.226.112-.226a23.76 23.76 0 0 1 31.879-10.692 23.9 23.9 0 0 1 10.762 10.832l.109.224-.112.225zm4.482-2.65a28.9 28.9 0 0 0-13.02-13.1A28.75 28.75 0 0 0 4.21 27.484L3 29.917l1.2 2.439a28.97 28.97 0 0 0 25.843 16.118h.114a28.62 28.62 0 0 0 25.63-15.952L57 30.089z",
      fill: "currentColor"
    })]
  });
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEye1);
var ForwardRef$1 = ForwardRef;

export { ForwardRef$1 as default };
